export default "__VITE_PUBLIC_ASSET__8745988b__"